/*
 * LyteWork Plastic Nameplate Customizer v4.4
 * Fixes: Volume Pricing Display on Size Change, Text-to-Fit Sizing Formula, Manual List Disabled for Text-to-Fit
 */

class PlasticNameplateCustomizer {
    constructor() {
        // Backup Pricing
        const defaultStandardPricing = {
            "2.5x0.75": { base: 2.71, tiers: [{min: 100, price: 2.59}, {min: 250, price: 2.44}] },
            "2.5x1":    { base: 3.77, tiers: [{min: 100, price: 3.44}, {min: 250, price: 3.02}] },
            "3x1":      { base: 3.87, tiers: [{min: 100, price: 3.54}, {min: 250, price: 3.13}] },
            "3x2":      { base: 5.62, tiers: [{min: 100, price: 5.09}, {min: 250, price: 4.51}] },
            "3x3":      { base: 5.67, tiers: [{min: 100, price: 5.56}, {min: 250, price: 5.30}] },
            "4x1.5":    { base: 5.62, tiers: [{min: 100, price: 4.85}, {min: 250, price: 4.34}] },
            "4x2":      { base: 6.31, tiers: [{min: 100, price: 5.72}, {min: 250, price: 4.99}] },
            "4x4":      { base: 7.16, tiers: [{min: 100, price: 7.00}, {min: 250, price: 6.83}] },
            "5x3":      { base: 7.16, tiers: [{min: 100, price: 7.00}, {min: 250, price: 6.83}] },
            "6x2":      { base: 6.72, tiers: [{min: 100, price: 6.16}, {min: 250, price: 5.30}] },
            "6x3":      { base: 7.73, tiers: [{min: 100, price: 7.07}, {min: 250, price: 6.16}] },
            "6x4":      { base: 8.48, tiers: [{min: 100, price: 7.78}, {min: 250, price: 6.77}] },
            "8x2":      { base: 9.60, tiers: [{min: 100, price: 9.39}, {min: 250, price: 9.23}] },
            "8x4":      { base: 18.50, tiers: [{min: 100, price: 17.50}, {min: 250, price: 16.50}] }
        };

        // 1. Configuration
        this.config = {
            pricing: window.lw_nameplate_config?.pricing || {
                base_fee: 0.00,
                per_square_inch: 0.95,
                add_ons: { holes: 0.50, adhesive: 0.00 },
                bulk_tiers: [],
                standard_pricing: defaultStandardPricing
            },
            specs: {
                hole_diameter: 0.1875,
                hole_offset: 0.25,
                corner_radius: 0.00,   
                margin_standard: 0.25, 
                margin_holes: 0.65     
            },
            standardPricing: window.lw_nameplate_config?.pricing?.standard_pricing || defaultStandardPricing,
            
            standardSizes: [
                { w: 2.5, h: 0.75, label: '2-1/2 × 3/4"' },
                { w: 2.5, h: 1.0,  label: '2-1/2 × 1"' },
                { w: 3.0, h: 1.0,  label: '3 × 1"' },
                { w: 3.0, h: 2.0,  label: '3 × 2"' },
                { w: 3.0, h: 3.0,  label: '3 × 3"' },
                { w: 4.0, h: 1.5,  label: '4 × 1-1/2"' },
                { w: 4.0, h: 2.0,  label: '4 × 2"' },
                { w: 4.0, h: 4.0,  label: '4 × 4"' },
                { w: 5.0, h: 3.0,  label: '5 × 3"' },
                { w: 6.0, h: 2.0,  label: '6 × 2"' },
                { w: 6.0, h: 3.0,  label: '6 × 3"' },
                { w: 6.0, h: 4.0,  label: '6 × 4"' },
                { w: 8.0, h: 2.0,  label: '8 × 2"' },
                { w: 8.0, h: 4.0,  label: '8 × 4"' }
            ],
            colors: [
                { id: 'black-white', name: 'Black / White Text', bg: '#000000', text: '#FFFFFF' },
                { id: 'white-black', name: 'White / Black Text', bg: '#FFFFFF', text: '#000000' },
                { id: 'red-white',   name: 'Red / White Text',   bg: '#D32F2F', text: '#FFFFFF' },
                { id: 'blue-white',  name: 'Blue / White Text',  bg: '#1976D2', text: '#FFFFFF' },
                { id: 'yellow-black', name: 'Yellow / Black Text', bg: '#FBC02D', text: '#000000' },
                { id: 'green-white', name: 'Green / White Text', bg: '#388E3C', text: '#FFFFFF' },
                { id: 'grey-black',  name: 'Grey / Black Text',  bg: '#9E9E9E', text: '#000000' },
                { id: 'orange-white', name: 'Orange / White Text', bg: '#F57C00', text: '#FFFFFF' },
                { id: 'brown-white', name: 'Brown / White Text', bg: '#5D4037', text: '#FFFFFF' }
            ],
            mountings: [
                { id: 'adhesive', name: 'Adhesive Backing', type: 'adhesive', holes: 0, location: null },
                { id: 'holes-2-end', name: '2 End Holes', type: 'holes', holes: 2, location: 'center-ends' },
                { id: 'holes-2-top', name: '2 Top Holes', type: 'holes', holes: 2, location: 'top-corners' },
                { id: 'holes-4',     name: '4 Corner Holes', type: 'holes', holes: 4, location: 'corners' }
            ],
            fonts: [
                { name: 'Helvetica', value: 'Helvetica, Arial, sans-serif' },
                { name: 'Times New Roman', value: "'Times New Roman', serif" },
                { name: 'Courier New', value: "'Courier New', monospace" }
            ],
            toolingSizes: [0.25, 0.375, 0.5, 0.625, 0.75, 1.0, 1.5, 2.0]
        };

        this.state = {
            sizeMode: 'standard',
            width: 2.5,
            height: 0.75,
            color: this.config.colors[0],
            mounting: this.config.mountings[0],
            textMode: 'lines',
            textLines: [{ id: 1, text: "", fontSize: 0.25, fontFamily: "Helvetica, Arial, sans-serif" }],
            textToFit: "",
            calculatedFitSize: 0.25, 
            quantity: 1,
            multiplesType: 'identical', 
            bulkMode: 'manual',
            bulkData: [['']], 
            fileUpload: null,
            finalUnitPrice: 0,
            finalTotal: 0
        };

        this.modal = null;
        this.init();
    }

    init() {
        this.attachTrigger();
    }

    attachTrigger() {
        const selector = '.lw-nameplate-trigger';
        const checkInterval = setInterval(() => {
            const trigger = document.querySelector(selector);
            if (trigger) {
                if (!trigger.hasAttribute('data-attached')) {
                    trigger.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.open();
                    });
                    trigger.setAttribute('data-attached', 'true');
                }
                clearInterval(checkInterval);
            }
        }, 100);
        setTimeout(() => clearInterval(checkInterval), 5000);
    }

    open() {
        this.buildModal();
        this.syncBulkDataToQuantity();
        this.updatePreview();
        this.updatePrice();
        document.body.classList.add('lw-modal-open');
        this.applyMobileStyles();
        window.addEventListener('resize', () => this.applyMobileStyles());
    }

    close() {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
            document.body.classList.remove('lw-modal-open');
            window.removeEventListener('resize', () => this.applyMobileStyles());
        }
    }

    applyMobileStyles() {
        if (!this.modal) return;
        const previewSec = this.modal.querySelector('.lw-deskplate-preview-section');
        if (window.innerWidth <= 1024) {
            previewSec.style.height = '35vh';
            previewSec.style.minHeight = '220px';
            previewSec.style.flexShrink = '0';
        } else {
            previewSec.style.height = '';
            previewSec.style.minHeight = '';
        }
    }

    buildModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'lw-deskplate-modal';
        
        this.modal.innerHTML = `
            <div class="lw-deskplate-overlay"></div>
            <div class="lw-deskplate-container">
                <header class="lw-deskplate-header">
                    <div class="lw-header-left">
                        <img src="https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Lw_logo_04_Artboard_2_Copy_3.png" class="lw-logo">
                        <div>
                            <h2>Custom Engraved Nameplate</h2>
                            <p class="lw-variant-subtitle">Plastic Nameplate</p>
                        </div>
                    </div>
                    <button class="lw-deskplate-close">&times;</button>
                </header>

                <div class="lw-deskplate-body">
                    <div class="lw-deskplate-preview-section">
                        <div id="svgContainerWrapper" style="width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 20px; box-sizing: border-box;">
                            <div id="svgContainer" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; filter: drop-shadow(0px 4px 8px rgba(0,0,0,0.2));"></div>
                            <p style="font-size: 14px; color: #666; margin-top: 15px; flex-shrink: 0;">
                                <span class="lw-dimensions-display">2.5" x 0.75"</span>
                            </p>
                        </div>
                    </div>

                    <div class="lw-deskplate-options-section">
                        <div class="lw-deskplate-tabs">
                            <button class="lw-deskplate-tab active" data-tab="specs">Specs & Size</button>
                            <button class="lw-deskplate-tab" data-tab="text">Text Content</button>
                            <button class="lw-deskplate-tab" data-tab="bulk">Multiples</button>
                        </div>
                        <div class="lw-deskplate-tab-content"></div>
                    </div>
                </div>

                <footer class="lw-deskplate-footer">
                    <div class="lw-footer-left">
                         <div style="font-size: 13px; color: #666;">Per: <strong class="lw-unit-price-display">$0.00</strong></div>
                         <div style="font-size: 18px; color: #233354; font-weight: 700;">Total: <span class="lw-price-val">$0.00</span></div>
                    </div>
                    <div class="lw-footer-center">
                        <div class="lw-quantity-control" style="margin:0;">
                            <button class="lw-qty-btn" data-action="decrease">-</button>
                            <input type="number" class="lw-qty-input" value="1" min="1">
                            <button class="lw-qty-btn" data-action="increase">+</button>
                        </div>
                    </div>
                    <div class="lw-footer-right">
                        <button type="button" class="lw-deskplate-btn lw-deskplate-btn-primary" id="addToCartBtn" style="margin:0; padding: 10px 28px;">Add to Cart</button>
                    </div>
                </footer>
            </div>
        `;

        document.body.appendChild(this.modal);
        this.switchTab('specs');
        this.attachGlobalEvents();
        this.applyMobileStyles();
    }

    // === RENDERERS ===

    renderSpecsTab() {
        const isCustom = this.state.sizeMode === 'custom';
        let priceTableHtml = '';
        
        if (isCustom) {
            priceTableHtml = `
                <div class="lw-price-table-mini">
                    <strong>Bulk Discounts (Custom Size)</strong>
                    <ul>
                        ${this.config.pricing.bulk_tiers.map(t => `<li>${t.min}+ items: <strong>${t.discount * 100}% Off</strong></li>`).join('')}
                    </ul>
                </div>
            `;
        } else {
            const key = `${this.state.width}x${this.state.height}`;
            const stdData = this.config.standardPricing[key];
            if (stdData && stdData.tiers) {
                priceTableHtml = `
                    <div class="lw-price-table-mini">
                        <strong>Volume Pricing (Per Plate)</strong>
                        <div style="display:flex; flex-wrap:wrap; gap:10px; margin-top:5px; font-size:13px;">
                            <div>1-99: <strong>$${stdData.base.toFixed(2)}</strong></div>
                            ${stdData.tiers.map(t => `<div>${t.min}+: <strong>$${t.price.toFixed(2)}</strong></div>`).join('')}
                        </div>
                    </div>
                `;
            }
        }

        return `
            <div class="lw-deskplate-tab-pane active">
                <h4>Size Selection</h4>
                <div style="display: flex; gap: 20px; margin-bottom: 15px;">
                    <label class="lw-checkbox-option">
                        <input type="radio" name="sizeMode" value="standard" ${!isCustom ? 'checked' : ''}>
                        <span>Standard Sizes</span>
                    </label>
                    <label class="lw-checkbox-option">
                        <input type="radio" name="sizeMode" value="custom" ${isCustom ? 'checked' : ''}>
                        <span>Custom Size</span>
                    </label>
                </div>

                <div id="standardSizeControls" style="display: ${!isCustom ? 'block' : 'none'}; margin-bottom: 20px;">
                    <select class="lw-table-input" id="standardSizeSelect">
                        ${this.config.standardSizes.map(s => {
                            const val = `${s.w}x${s.h}`;
                            const selected = (s.w === this.state.width && s.h === this.state.height) ? 'selected' : '';
                            return `<option value="${val}" ${selected}>${s.label}</option>`;
                        }).join('')}
                    </select>
                </div>

                <div id="customSizeControls" style="display: ${isCustom ? 'flex' : 'none'}; gap: 15px; margin-bottom: 20px;">
                    <div style="flex: 1;">
                        <label style="font-size: 12px; font-weight:600;">Width (in)</label>
                        <input type="number" id="customW" class="lw-table-input" value="${this.state.width}" min="1" max="24" step="0.125">
                    </div>
                    <div style="flex: 1;">
                        <label style="font-size: 12px; font-weight:600;">Height (in)</label>
                        <input type="number" id="customH" class="lw-table-input" value="${this.state.height}" min="0.5" max="12" step="0.125">
                    </div>
                </div>

                <h4>Color</h4>
                <div class="lw-color-grid" style="grid-template-columns: repeat(3, 1fr);">
                    ${this.config.colors.map(c => `
                        <div class="lw-color-option ${this.state.color.id === c.id ? 'active' : ''}" data-color-id="${c.id}">
                            <div style="width: 100%; height: 30px; background: ${c.bg}; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; margin-bottom: 5px;">
                                <span style="color: ${c.text}; font-weight: bold; font-size: 12px;">ABC</span>
                            </div>
                            <span>${c.name}</span>
                        </div>
                    `).join('')}
                </div>

                <h4>Mounting Holes</h4>
                <select class="lw-table-input" id="mountingSelect">
                    ${this.config.mountings.map(m => 
                        `<option value="${m.id}" ${this.state.mounting.id === m.id ? 'selected' : ''}>${m.name}</option>`
                    ).join('')}
                </select>

                ${priceTableHtml ? `
                <div style="margin-top: 20px; background: #f0f4ff; padding: 15px; border-radius: 8px;">
                    ${priceTableHtml}
                </div>
                ` : ''}
            </div>
        `;
    }

    renderTextTab() {
        const isFit = this.state.textMode === 'fit';
        const fitSizeFrac = this.decimalToFraction(this.state.calculatedFitSize);

        const linesHtml = this.state.textLines.map((line, idx) => `
            <div class="lw-text-field" data-line-index="${idx}">
                <div class="lw-field-header">
                    <label>Line ${idx + 1}</label>
                    <div class="lw-field-controls">
                        <select class="lw-font-select line-font" style="width:110px">
                            ${this.config.fonts.map(f => 
                                `<option value="${f.value}" ${line.fontFamily === f.value ? 'selected' : ''}>${f.name}</option>`
                            ).join('')}
                        </select>
                        <select class="lw-font-select line-size" style="width:80px">
                            ${this.generateFontSizeOptions(line.fontSize)}
                        </select>
                        ${idx > 0 ? `<button class="lw-remove-line-btn" style="background: #fff; color: #d32f2f; border: 1px solid #d32f2f; border-radius: 4px; cursor: pointer; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;" data-index="${idx}">&times;</button>` : ''}
                    </div>
                </div>
                <input type="text" class="lw-table-input line-text" value="${line.text}" placeholder="Text line ${idx+1}" style="text-transform:uppercase;">
                <div class="lw-help-text" style="margin-top: 5px; font-size: 11px;">
                    Max Characters: ${this.getMaxChars(line.fontSize, this.state.width)}
                </div>
            </div>
        `).join('');

        return `
            <div class="lw-deskplate-tab-pane active">
                <div class="lw-info-box">
                    <strong>Note: Text is automatically capitalized. </strong>
                </div>
                
                <div style="display: flex; gap: 10px; margin-bottom: 15px; background: #eee; padding: 5px; border-radius: 8px;">
                    <button class="lw-deskplate-tab ${!isFit ? 'active' : ''}" style="flex:1; border:none; background: ${!isFit?'white':'transparent'}; border-radius:6px; height:40px;" id="modeLinesBtn">DIY Lines</button>
                    <button class="lw-deskplate-tab ${isFit ? 'active' : ''}" style="flex:1; border:none; background: ${isFit?'white':'transparent'}; border-radius:6px; height:40px;" id="modeFitBtn">Fit My Text</button>
                </div>

                ${!isFit ? `
                    <div id="linesContainer">
                        ${linesHtml}
                        ${this.state.textLines.length < 4 ? 
                            `<button class="lw-deskplate-btn lw-deskplate-btn-secondary" id="addLineBtn" style="width:100%">+ Add Line</button>` : ''}
                    </div>
                ` : `
                    <div id="fitContainer">
                        <label style="font-weight:600; display:block; margin-bottom:8px;">Enter Text (Auto-Scaled)</label>
                        <textarea class="lw-table-input" id="textToFitInput" rows="4" placeholder="Enter text..." style="text-transform:uppercase;">${this.state.textToFit}</textarea>
                        <p class="lw-help-text">Enter implies new line.</p>
                        
                        <div style="margin-top:15px; padding:10px; background:#f0f4ff; border:1px solid #b8c6e0; border-radius:6px;">
                            <strong>Calculated Text Size:</strong> <span id="calcSizeDisplay">${fitSizeFrac}"</span> Height <br>
                            <em style="font-size:12px; color:#666;">Snaps to nearest standard tool size.</em>
                        </div>
                    </div>
                `}
            </div>
        `;
    }

    renderBulkTab() {
        const isIdentical = this.state.multiplesType === 'identical';
        const isCsv = this.state.bulkMode === 'csv';
        const isFile = this.state.bulkMode === 'file';
        const isManual = this.state.bulkMode === 'manual';

        // FIX #3: For Text-to-Fit mode, force file upload only (disable manual list)
        const isFitMode = this.state.textMode === 'fit';
        
        const colCount = isFitMode ? 1 : this.state.textLines.length;
        const columns = [];
        for(let i=0; i<colCount; i++) columns.push(isFitMode ? 'Text to Fit' : `Line ${i+1}`);

        return `
            <div class="lw-deskplate-tab-pane active">
                <div class="lw-info-box">
                    <strong>Ordering Multiples?</strong><br>
                    Choose if all plates are the same, or if each plate has unique text.
                </div>

                <div style="display:flex; gap:10px; margin-bottom:20px; border-bottom:1px solid #eee; padding-bottom:15px;">
                    <label class="lw-checkbox-option">
                        <input type="radio" name="multiplesType" value="identical" ${isIdentical ? 'checked' : ''}>
                        <span>Same Text on All</span>
                    </label>
                    <label class="lw-checkbox-option">
                        <input type="radio" name="multiplesType" value="variable" ${!isIdentical ? 'checked' : ''}>
                        <span>Different Text Per Plate</span>
                    </label>
                </div>

                ${isIdentical ? `
                    <div style="padding:10px; text-align:center;">
                        <p style="color:#666; font-size:13px;">All ${this.state.quantity} plates will use the exact text defined in the "Text Content" tab.</p>
                        <p><strong>Adjust quantity in the footer below.</strong></p>
                    </div>
                ` : `
                    <div>
                        ${isFitMode ? `
                            <!-- FIX #3: Text-to-Fit mode only allows file upload -->
                            <div style="padding:10px; background:#fff3cd; border:1px solid #ffc107; border-radius:8px; margin-bottom:15px;">
                                <strong>⚠️ Text-to-Fit Mode:</strong> Manual list entry is not available for multi-line text. Please use file upload instead.
                            </div>
                            <div style="display:flex; gap:5px; margin-bottom:15px;">
                                <button class="lw-deskplate-btn" id="bulkCsvBtn" style="flex:1; padding:10px 5px; font-size:13px; background:${isCsv ? '#233354' : 'white'}; color:${isCsv ? 'white' : '#233354'}; border:1px solid #233354;">Upload CSV</button>
                                <button class="lw-deskplate-btn" id="bulkFileBtn" style="flex:1; padding:10px 5px; font-size:13px; background:${isFile ? '#233354' : 'white'}; color:${isFile ? 'white' : '#233354'}; border:1px solid #233354;">Upload File</button>
                            </div>
                        ` : `
                            <div style="display:flex; gap:5px; margin-bottom:15px;">
                                <button class="lw-deskplate-btn" id="bulkManualBtn" style="flex:1; padding:10px 5px; font-size:13px; background:${isManual ? '#233354' : 'white'}; color:${isManual ? 'white' : '#233354'}; border:1px solid #233354;">Manual List</button>
                                <button class="lw-deskplate-btn" id="bulkCsvBtn" style="flex:1; padding:10px 5px; font-size:13px; background:${isCsv ? '#233354' : 'white'}; color:${isCsv ? 'white' : '#233354'}; border:1px solid #233354;">Upload CSV</button>
                                <button class="lw-deskplate-btn" id="bulkFileBtn" style="flex:1; padding:10px 5px; font-size:13px; background:${isFile ? '#233354' : 'white'}; color:${isFile ? 'white' : '#233354'}; border:1px solid #233354;">Upload File</button>
                            </div>
                        `}

                        <div id="manualBulkSection" style="display: ${isManual && !isFitMode ? 'block' : 'none'}">
                            <div class="lw-plates-table-wrapper" style="max-height: 300px; overflow-y:auto;">
                                <table class="lw-plates-table">
                                    <thead>
                                        <tr>
                                            <th width="30">#</th>
                                            ${columns.map(c => `<th>${c}</th>`).join('')}
                                            <th width="30"></th>
                                        </tr>
                                    </thead>
                                    <tbody id="manualBulkBody">
                                        ${this.state.bulkData.map((row, i) => `
                                            <tr data-idx="${i}">
                                                <td>${i+1}</td>
                                                ${columns.map((_, cIdx) => `
                                                    <td><input type="text" class="lw-table-input manual-input" data-col="${cIdx}" value="${row[cIdx] || ''}" style="text-transform:uppercase;"></td>
                                                `).join('')}
                                                <td><button class="lw-remove-line-btn remove-bulk-row" data-idx="${i}" style="background:transparent; color:#d32f2f; border:none; font-size:18px; font-weight:bold;">&times;</button></td>
                                            </tr>
                                        `).join('')}
                                    </tbody>
                                </table>
                            </div>
                            <div style="display:flex; gap:10px; margin-top:10px;">
                                <button class="lw-deskplate-btn lw-deskplate-btn-secondary" id="addBulkRowBtn" style="flex:1;">+ Add Row</button>
                                <button class="lw-deskplate-btn" id="clearBulkBtn" style="background:#fff; border:1px solid #d32f2f; color:#d32f2f;">Clear</button>
                            </div>
                        </div>

                        <div id="csvBulkSection" style="display: ${isCsv ? 'block' : 'none'}">
                            <div class="lw-logo-upload">
                                <div class="lw-upload-area" id="csvUploadArea">
                                    <div class="lw-upload-prompt">
                                        <span style="font-size: 32px;">📂</span>
                                        <span>Click to Upload CSV/TXT</span>
                                    </div>
                                </div>
                                <input type="file" id="csvInput" accept=".csv,.txt,.xlsx" style="display: none;">
                            </div>
                            ${isFitMode ? `
                                <p style="text-align:center; font-size:13px; color:#666; margin-top:10px;">
                                    <strong>CSV Format:</strong> One name/text block per line. Use "|" (pipe) to separate multiple lines within each plate.<br>
                                    Example: "John Smith|Manager" creates a plate with two lines.
                                </p>
                            ` : `
                                <p style="text-align:center; font-size:13px; color:#666;">Uploading a file will switch back to Manual List view automatically.</p>
                            `}
                        </div>

                        <div id="fileBulkSection" style="display: ${isFile ? 'block' : 'none'}">
                            <div class="lw-logo-upload">
                                <div class="lw-upload-area ${this.state.fileUpload ? 'has-file' : ''}" id="fileUploadArea">
                                    <div class="lw-upload-prompt">
                                        <span style="font-size: 32px;">📎</span>
                                        <span>${this.state.fileUpload ? this.state.fileUpload.name : 'Click to Upload PDF / Image'}</span>
                                    </div>
                                </div>
                                <input type="file" id="fileInput" accept=".pdf,.jpg,.png,.doc,.docx" style="display: none;">
                            </div>
                            <div style="text-align:center; margin-top:10px;">
                                 <p style="font-size:13px; color:#666;"><strong>Note:</strong> When using this method, please ensure the <strong>Qty</strong> in the footer matches your file.</p>
                            </div>
                        </div>
                    </div>
                `}
            </div>
        `;
    }

    // === HELPERS ===

    /**
     * FIX #2: Improved Text-to-Fit sizing formula
     * Uses more generous spacing and considers line spacing multiplier
     */
    snapFitSize(calculatedSize) {
        const sizes = this.config.toolingSizes;
        const sorted = sizes.slice().sort((a,b) => b - a);
        const snapped = sorted.find(s => s <= calculatedSize);
        return snapped || sizes[0];
    }

    /**
     * FIX #2: New method to calculate optimal fit size
     * More generous formula that accounts for actual usable height
     */
    calculateFitSize(plateHeight, lineCount) {
        // Use 80% of plate height (was 70%) to allow more generous sizing
        const usableHeight = plateHeight * 0.80;
        
        // Line spacing multiplier (1.15 is used in preview rendering)
        const lineSpacing = 1.15;
        
        // Calculate raw size based on total block height
        // Total block height = lineCount * fontSize * lineSpacing
        // So fontSize = usableHeight / (lineCount * lineSpacing)
        const rawSize = usableHeight / (Math.max(1, lineCount) * lineSpacing);
        
        // Cap at 2" max (largest tooling size)
        const cappedSize = Math.min(2.0, rawSize);
        
        // Snap to nearest tooling size
        return this.snapFitSize(cappedSize);
    }

    syncBulkDataToQuantity() {
        if (this.state.multiplesType === 'variable') {
            const target = this.state.quantity;
            const colCount = this.state.textMode === 'fit' ? 1 : this.state.textLines.length;
            
            while(this.state.bulkData.length < target) {
                this.state.bulkData.push(new Array(colCount).fill(''));
            }
            while(this.state.bulkData.length > target) {
                this.state.bulkData.pop();
            }
        }
    }

    normalizeBulkDataColumns() {
        const colCount = this.state.textMode === 'fit' ? 1 : this.state.textLines.length;
        this.state.bulkData = this.state.bulkData.map(row => {
            if (row.length < colCount) return [...row, ...new Array(colCount - row.length).fill('')];
            if (row.length > colCount) return row.slice(0, colCount);
            return row;
        });
    }

    generateFontSizeOptions(currentSize) {
        const sizes = [0.25, 0.375, 0.5, 0.625, 0.75, 1.0, 1.5, 2.0];
        const heightLimit = this.state.height - 0.25; 
        return sizes
            .filter(s => s <= heightLimit)
            .map(s => {
                const label = this.decimalToFraction(s);
                const selected = Math.abs(s - currentSize) < 0.01 ? 'selected' : '';
                return `<option value="${s}" ${selected}>${label}" Height</option>`;
            }).join('');
    }

    decimalToFraction(dec) {
        const map = { 0.25: "1/4", 0.375: "3/8", 0.5: "1/2", 0.625: "5/8", 0.75: "3/4", 1.0: "1", 1.5: "1-1/2", 2.0: "2" };
        return map[dec] || dec;
    }

    getMaxChars(fontSize, plateWidth) {
        const margin = (this.state.mounting.holes > 0) ? this.config.specs.margin_holes : this.config.specs.margin_standard;
        const charWidthAvg = fontSize * 0.6; 
        const usableWidth = plateWidth - (margin * 2); 
        return Math.floor(Math.max(0, usableWidth / charWidthAvg));
    }

    // === EVENT HANDLING ===

    attachGlobalEvents() {
        this.modal.querySelector('.lw-deskplate-close').addEventListener('click', () => this.close());
        this.modal.querySelector('.lw-deskplate-overlay').addEventListener('click', () => this.close());
        
        this.modal.querySelectorAll('.lw-deskplate-tab').forEach(tab => {
            tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
        });

        this.modal.querySelector('#addToCartBtn').addEventListener('click', () => this.addToCart());

        this.modal.querySelectorAll('.lw-footer-center .lw-qty-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const inp = this.modal.querySelector('.lw-footer-center .lw-qty-input');
                let v = parseInt(inp.value) + (btn.dataset.action==='increase'?1:-1);
                v = Math.max(1, v);
                inp.value = v; 
                this.state.quantity = v; 
                this.syncBulkDataToQuantity(); 
                if (this.state.multiplesType === 'variable' && this.modal.querySelector('.lw-deskplate-tab[data-tab="bulk"]').classList.contains('active')) {
                    this.switchTab('bulk');
                }
                this.updatePrice();
            });
        });
        
        const qInput = this.modal.querySelector('.lw-footer-center .lw-qty-input');
        if(qInput) qInput.addEventListener('change', (e) => { 
            this.state.quantity = Math.max(1, parseInt(e.target.value)||1); 
            this.syncBulkDataToQuantity(); 
             if (this.state.multiplesType === 'variable' && this.modal.querySelector('.lw-deskplate-tab[data-tab="bulk"]').classList.contains('active')) {
                this.switchTab('bulk');
            }
            this.updatePrice(); 
        });
    }

    switchTab(tabName) {
        this.modal.querySelectorAll('.lw-deskplate-tab').forEach(t => t.classList.toggle('active', t.dataset.tab === tabName));
        const content = this.modal.querySelector('.lw-deskplate-tab-content');
        
        if (tabName === 'bulk') {
             this.normalizeBulkDataColumns();
             // FIX #3: If switching to bulk tab in fit mode, force file upload mode
             if(this.state.textMode === 'fit' && this.state.bulkMode === 'manual') {
                 this.state.bulkMode = 'file';
             } else if(this.state.bulkMode === 'none') {
                 this.state.bulkMode = 'manual';
             }
             content.innerHTML = this.renderBulkTab(); 
             this.attachBulkEvents(); 
        } else if(tabName === 'specs') { 
            content.innerHTML = this.renderSpecsTab(); 
            this.attachSpecsEvents(); 
        } else if(tabName === 'text') { 
            content.innerHTML = this.renderTextTab(); 
            this.attachTextEvents(); 
        }
    }

    attachSpecsEvents() {
        this.modal.querySelectorAll('input[name="sizeMode"]').forEach(r => {
            r.addEventListener('change', (e) => {
                this.state.sizeMode = e.target.value;
                if (this.state.sizeMode === 'standard') this.updateSize(2.5, 0.75);
                this.switchTab('specs');
            });
        });

        const std = this.modal.querySelector('#standardSizeSelect');
        if(std) std.addEventListener('change', (e) => { 
            const [w,h] = e.target.value.split('x'); 
            this.updateSize(parseFloat(w), parseFloat(h)); 
            // FIX #1: Re-render specs tab to update volume pricing display
            this.switchTab('specs');
        });

        const cW = this.modal.querySelector('#customW');
        const cH = this.modal.querySelector('#customH');
        if(cW) {
            const up = () => this.updateSize(parseFloat(cW.value), parseFloat(cH.value));
            cW.addEventListener('input', up); cH.addEventListener('input', up);
        }

        this.modal.querySelectorAll('.lw-color-option').forEach(el => {
            el.addEventListener('click', () => {
                this.state.color = this.config.colors.find(c => c.id === el.dataset.colorId);
                this.switchTab('specs');
                this.updatePreview();
            });
        });

        const mnt = this.modal.querySelector('#mountingSelect');
        if(mnt) mnt.addEventListener('change', (e) => {
            this.state.mounting = this.config.mountings.find(m => m.id === e.target.value);
            this.updatePreview(); this.updatePrice();
        });
    }

    attachTextEvents() {
        const modeLines = this.modal.querySelector('#modeLinesBtn');
        const modeFit = this.modal.querySelector('#modeFitBtn');
        if(modeLines) {
            modeLines.addEventListener('click', () => { this.state.textMode = 'lines'; this.switchTab('text'); this.updatePreview(); });
            modeFit.addEventListener('click', () => { this.state.textMode = 'fit'; this.switchTab('text'); this.updatePreview(); });
        }

        this.modal.querySelectorAll('.line-text').forEach(inp => {
            inp.addEventListener('input', (e) => {
                const i = e.target.closest('.lw-text-field').dataset.lineIndex;
                this.state.textLines[i].text = e.target.value.toUpperCase(); 
                e.target.value = this.state.textLines[i].text;
                if(this.state.bulkData[0]) this.state.bulkData[0][i] = e.target.value;
                this.updatePreview();
            });
        });

        this.modal.querySelectorAll('.line-font').forEach(sel => {
            sel.addEventListener('change', (e) => {
                const i = e.target.closest('.lw-text-field').dataset.lineIndex;
                this.state.textLines[i].fontFamily = e.target.value;
                this.updatePreview();
            });
        });

        this.modal.querySelectorAll('.line-size').forEach(sel => {
            sel.addEventListener('change', (e) => {
                const i = e.target.closest('.lw-text-field').dataset.lineIndex;
                this.state.textLines[i].fontSize = parseFloat(e.target.value);
                this.switchTab('text'); 
                this.updatePreview();
            });
        });

        const fitInput = this.modal.querySelector('#textToFitInput');
        if(fitInput) {
            fitInput.addEventListener('input', (e) => {
                this.state.textToFit = e.target.value.toUpperCase();
                e.target.value = this.state.textToFit;
                if(this.state.bulkData[0]) this.state.bulkData[0][0] = e.target.value;
                this.updatePreview();
                
                // Update only the size display without re-rendering the tab
                const display = this.modal.querySelector('#calcSizeDisplay');
                if (display) {
                    display.textContent = this.decimalToFraction(this.state.calculatedFitSize) + '"';
                }
            });
        }

        const addBtn = this.modal.querySelector('#addLineBtn');
        if(addBtn) addBtn.addEventListener('click', () => {
            this.state.textLines.push({ text: "", fontSize: 0.25, fontFamily: "Helvetica, Arial, sans-serif" });
            this.switchTab('text');
            this.updatePreview();
        });

        this.modal.querySelectorAll('.lw-remove-line-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                this.state.textLines.splice(e.target.dataset.index, 1);
                this.switchTab('text');
                this.updatePreview();
            });
        });
    }

    attachBulkEvents() {
        this.modal.querySelectorAll('input[name="multiplesType"]').forEach(r => {
            r.addEventListener('change', (e) => {
                this.state.multiplesType = e.target.value;
                if(this.state.multiplesType === 'variable') {
                    // FIX #3: If in fit mode, force file upload
                    this.state.bulkMode = this.state.textMode === 'fit' ? 'file' : 'manual';
                    this.syncBulkDataToQuantity();
                }
                this.switchTab('bulk');
            });
        });

        const manBtn = this.modal.querySelector('#bulkManualBtn');
        const csvBtn = this.modal.querySelector('#bulkCsvBtn');
        const fileBtn = this.modal.querySelector('#bulkFileBtn');
        
        if(manBtn) {
            manBtn.addEventListener('click', () => { 
                this.state.bulkMode = 'manual'; 
                if(this.state.bulkData.length === 0) this.state.bulkData = [['','']]; 
                this.switchTab('bulk'); 
                this.updatePrice();
            });
        }
        if(csvBtn) {
            csvBtn.addEventListener('click', () => { 
                this.state.bulkMode = 'csv'; 
                this.switchTab('bulk'); 
            });
        }
        if(fileBtn) {
            fileBtn.addEventListener('click', () => {
                this.state.bulkMode = 'file';
                this.switchTab('bulk');
            });
        }

        const addRow = this.modal.querySelector('#addBulkRowBtn');
        if(addRow) {
            addRow.addEventListener('click', () => {
                const colCount = this.state.textMode === 'fit' ? 1 : this.state.textLines.length;
                this.state.bulkData.push(new Array(colCount).fill(''));
                this.state.quantity = this.state.bulkData.length;
                this.updateFooterQty();
                this.switchTab('bulk');
                this.updatePrice();
            });
        }

        this.modal.querySelectorAll('.manual-input').forEach(inp => {
            inp.addEventListener('input', (e) => {
                const r = e.target.closest('tr').dataset.idx;
                const c = e.target.dataset.col;
                const val = e.target.value.toUpperCase();
                e.target.value = val;
                if(!this.state.bulkData[r]) this.state.bulkData[r] = [];
                this.state.bulkData[r][c] = val;
                
                // Sync first row back to preview
                if(r == 0) {
                    if (this.state.textMode === 'fit') {
                        this.state.textToFit = val;
                        // Trigger fit calculation update
                        this.updatePreview();
                        const display = this.modal.querySelector('#calcSizeDisplay');
                        if (display) display.textContent = this.decimalToFraction(this.state.calculatedFitSize) + '"';
                    } else if (this.state.textLines[c]) {
                        this.state.textLines[c].text = val;
                        this.updatePreview();
                    }
                }
            });
        });

        this.modal.querySelectorAll('.remove-bulk-row').forEach(btn => {
            btn.addEventListener('click', (e) => {
                this.state.bulkData.splice(e.target.dataset.idx, 1);
                this.state.quantity = Math.max(1, this.state.bulkData.length);
                this.updateFooterQty();
                this.switchTab('bulk');
                this.updatePrice();
                if(this.state.bulkData[0]) {
                    if(this.state.textMode === 'fit') {
                        this.state.textToFit = this.state.bulkData[0][0] || '';
                    } else {
                        this.state.bulkData[0].forEach((txt, i) => {
                            if(this.state.textLines[i]) this.state.textLines[i].text = txt || '';
                        });
                    }
                    this.updatePreview();
                }
            });
        });

        const clearBtn = this.modal.querySelector('#clearBulkBtn');
        if(clearBtn) {
            clearBtn.addEventListener('click', () => {
                this.state.bulkData = [['']];
                this.state.quantity = 1;
                this.updateFooterQty();
                this.switchTab('bulk');
                this.updatePrice();
            });
        }

        const fileArea = this.modal.querySelector('#csvUploadArea');
        const fileInput = this.modal.querySelector('#csvInput');
        if(fileArea) {
            fileArea.addEventListener('click', () => fileInput.click());
            fileInput.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if(!file) return;
                const r = new FileReader();
                r.onload = (evt) => {
                    const rows = evt.target.result.split(/\r?\n/).filter(x => x.trim());
                    
                    // FIX #3: For fit mode, handle pipe-separated lines within each row
                    if (this.state.textMode === 'fit') {
                        // Each row becomes one plate, pipes separate lines within that plate
                        this.state.bulkData = rows.map(row => [row.replace(/,/g, '|').trim().toUpperCase()]);
                    } else {
                        this.state.bulkData = rows.map(r => r.split(',').map(c => c.trim().toUpperCase()));
                    }
                    
                    this.state.quantity = this.state.bulkData.length;
                    this.state.bulkMode = this.state.textMode === 'fit' ? 'csv' : 'manual'; 
                    this.normalizeBulkDataColumns();
                    this.updateFooterQty();
                    this.switchTab('bulk');
                    this.updatePrice();
                    
                    if(this.state.bulkData[0]) {
                        if(this.state.textMode === 'fit') {
                            this.state.textToFit = this.state.bulkData[0][0] || '';
                        } else {
                            this.state.bulkData[0].forEach((txt, i) => {
                                if(this.state.textLines[i]) this.state.textLines[i].text = txt || '';
                            });
                        }
                        this.updatePreview();
                    }
                };
                r.readAsText(file);
            });
        }

        const pdfArea = this.modal.querySelector('#fileUploadArea');
        const pdfInput = this.modal.querySelector('#fileInput');
        if(pdfArea) {
            pdfArea.addEventListener('click', () => pdfInput.click());
            pdfInput.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if(!file) return;
                this.state.fileUpload = file;
                this.switchTab('bulk'); 
            });
        }
    }

    updateFooterQty() {
        const fInput = this.modal.querySelector('.lw-footer-center .lw-qty-input');
        if(fInput) fInput.value = this.state.quantity;
    }

    updateSize(w, h) {
        this.state.width = w;
        this.state.height = h;
        this.updatePreview();
        this.updatePrice();
        const d = this.modal.querySelector('.lw-dimensions-display');
        if(d) d.textContent = `${w}" x ${h}"`;
    }

    // === SVG PREVIEW ===
    updatePreview() {
        const c = this.modal.querySelector('#svgContainer');
        if(!c) return;

        const w = this.state.width;
        const h = this.state.height;
        const bg = this.state.color.bg;
        const fg = this.state.color.text;
        const r = this.config.specs.corner_radius;

        let holes = '';
        if (this.state.mounting.holes > 0) {
            const off = this.config.specs.hole_offset;
            const rad = this.config.specs.hole_diameter / 2;
            const loc = this.state.mounting.location;
            let pos = [];
            if (loc === 'corners') pos = [[off, off], [w-off, off], [off, h-off], [w-off, h-off]];
            if (loc === 'center-ends') pos = [[off, h/2], [w-off, h/2]];
            if (loc === 'top-corners') pos = [[off, off], [w-off, off]];
            holes = pos.map(p => `<circle cx="${p[0]}" cy="${p[1]}" r="${rad}" fill="white" stroke="#999" stroke-width="0.01" />`).join('');
        }

        let textSvg = '';
        const margin = (this.state.mounting.holes > 0) ? this.config.specs.margin_holes : this.config.specs.margin_standard;
        
        const createText = (txt, y, size, font) => {
            const maxW = w - (margin * 2);
            const estimatedW = txt.length * (size * 0.6);
            let compressAttr = '';
            if (estimatedW > maxW) {
                compressAttr = `textLength="${maxW}" lengthAdjust="spacingAndGlyphs"`;
            }
            return `<text x="${w/2}" y="${y}" font-family="${font}" font-size="${size}" fill="${fg}" 
                    text-anchor="middle" dominant-baseline="central" ${compressAttr}>${txt.replace(/&/g, '&amp;')}</text>`;
        };

        if (this.state.textMode === 'fit') {
            const lines = this.state.textToFit.split('\n');
            
            // FIX #2: Use improved calculation method
            const fontSize = this.calculateFitSize(h, lines.length);
            this.state.calculatedFitSize = fontSize; 

            const blockHeight = lines.length * fontSize * 1.15;
            const topY = (h / 2) - (blockHeight / 2) + (fontSize * 1.15 / 2);

            lines.forEach((line, i) => {
                textSvg += createText(line, topY + (i * fontSize * 1.15), fontSize, 'Helvetica, Arial, sans-serif');
            });
        } else {
            let totalBlockH = 0;
            this.state.textLines.forEach(l => totalBlockH += l.fontSize * 1.15);
            let currentY = (h / 2) - (totalBlockH / 2); 
            this.state.textLines.forEach((line) => {
                const lineCenter = currentY + (line.fontSize * 1.15 / 2);
                textSvg += createText(line.text, lineCenter, line.fontSize, line.fontFamily);
                currentY += (line.fontSize * 1.15);
            });
        }

        const svg = `
            <svg viewBox="0 0 ${w} ${h}" 
                 style="max-width: 100%; max-height: 100%; width: auto; height: auto; background:#fff;" 
                 xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                        <feDropShadow dx="0.02" dy="0.02" stdDeviation="0.03" flood-color="#000" flood-opacity="0.3"/>
                    </filter>
                </defs>
                <rect x="0" y="0" width="${w}" height="${h}" rx="${r}" fill="${bg}" stroke="#ccc" stroke-width="0.01" filter="url(#shadow)"/>
                ${holes}
                ${textSvg}
            </svg>
        `;
        c.innerHTML = svg;
    }

    // === PRICING ===
    updatePrice() {
        const p = this.config.pricing;
        const w = this.state.width;
        const h = this.state.height;
        const qty = this.state.quantity;

        let base = 0;
        if (this.state.sizeMode === 'custom') {
            const area = w * h;
            const calculated = p.custom_pricing?.per_square_inch * area || (area * 0.95);
            base = Math.max(p.custom_pricing?.min_price || 0, calculated);
        } else {
            const key = `${w}x${h}`; 
            const stdData = p.standard_pricing?.[key] || this.config.standardPricing[key];
            if (stdData) {
                base = stdData.base;
                const tiers = stdData.tiers || [];
                const match = tiers.sort((a,b)=>b.min-a.min).find(t => qty >= t.min);
                if (match) base = match.price;
            } else {
                base = Math.max(5.00, (w * h * 0.95));
            }
        }

        let adds = 0;
        if(this.state.mounting.type === 'holes') adds += p.add_ons.holes;
        if(this.state.mounting.type === 'adhesive') adds += p.add_ons.adhesive;

        const unitTotal = base + adds;
        const grandTotal = unitTotal * qty;
        
        this.state.finalUnitPrice = unitTotal;
        this.state.finalTotal = grandTotal;

        const disp = this.modal.querySelector('.lw-price-val');
        const unitDisp = this.modal.querySelector('.lw-unit-price-display');
        
        if(disp) disp.textContent = `$${grandTotal.toFixed(2)}`;
        if(unitDisp) unitDisp.textContent = `($${unitTotal.toFixed(2)} / plate)`;
    }

    // === CART ===
    async addToCart() {
        const btn = this.modal.querySelector('#addToCartBtn');
        btn.disabled = true;
        btn.textContent = 'Processing...';

        try {
            const previewUrl = await this.rasterizeSvg();
            const props = {
                '_Program': 'Nameplate v4.4',
                'Size': `${this.state.width}" x ${this.state.height}"`,
                'Color': this.state.color.name,
                'Mounting': this.state.mounting.name,
                '_preview': previewUrl
            };
            props['_addon_price'] = Math.round(this.state.finalUnitPrice * 100);

            if (this.state.multiplesType === 'variable') {
                props['Order Type'] = 'Variable Text (Bulk)';
                
                if (this.state.textMode !== 'fit') {
                    this.state.textLines.forEach((l, i) => {
                       props[`Spec Line ${i+1}`] = `${l.fontSize}" ${l.fontFamily.split(',')[0]}`;
                    });
                }
                
                if (this.state.bulkMode === 'file' && this.state.fileUpload) {
                     props['Order Type'] = 'File Upload';
                     props['Filename'] = this.state.fileUpload.name;
                } else if (this.state.bulkData.length > 0) {
                    props['Quantity'] = this.state.bulkData.length;
                    let listText = "";
                    this.state.bulkData.forEach((row, i) => {
                        if (listText.length < 800) listText += `[${i+1}] ${row.join(' | ')}\n`;
                    });
                    props['_Bulk_Summary'] = listText;
                    
                    // Generate CSV
                    const csvContent = this.state.bulkData.map(r => r.join(',')).join('\n');
                    this.csvFileToUpload = new File([csvContent], "bulk_order_list.csv", { type: "text/csv" });
                }

            } else {
                props['Order Type'] = 'Identical Copies';
                if (this.state.textMode === 'fit') {
                    props['Text Mode'] = 'Text to Fit';
                    props['Content'] = this.state.textToFit;
                    props['Fit Size'] = `${this.decimalToFraction(this.state.calculatedFitSize)}"`;
                } else {
                    this.state.textLines.forEach((l, i) => {
                        props[`Line ${i+1}`] = `${l.text}`;
                        props[`Line ${i+1} Spec`] = `${l.fontSize}" ${l.fontFamily.split(',')[0]}`;
                    });
                }
            }

            const formData = new FormData();
            const idInput = document.querySelector('input[name="id"]');
            if(!idInput) throw new Error("Product ID not found");
            
            formData.append('id', idInput.value);
            formData.append('quantity', this.state.quantity);
            Object.entries(props).forEach(([k,v]) => formData.append(`properties[${k}]`, v));
            
            if (this.state.bulkMode === 'file' && this.state.fileUpload) {
                 formData.append('properties[Uploaded File]', this.state.fileUpload);
            }
            if (this.csvFileToUpload) {
                 formData.append('properties[Order CSV]', this.csvFileToUpload);
            }

            const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
            if(res.ok) {
                this.close();
                window.location.href = '/cart';
            } else {
                throw new Error("Cart add failed");
            }

        } catch (e) {
            console.error(e);
            alert('Error adding to cart. Please try again.');
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
        }
    }

    rasterizeSvg() {
        return new Promise(resolve => {
            const svg = this.modal.querySelector('#svgContainer svg');
            if(!svg) { resolve(null); return; }
            const xml = new XMLSerializer().serializeToString(svg);
            const img = new Image();
            img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(xml)));
            img.onload = () => {
                const c = document.createElement('canvas');
                const scale = 2; 
                c.width = this.state.width * 100 * scale;
                c.height = this.state.height * 100 * scale;
                const ctx = c.getContext('2d');
                ctx.drawImage(img, 0, 0, c.width, c.height);
                resolve(c.toDataURL('image/png'));
            };
        });
    }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => new PlasticNameplateCustomizer());
else new PlasticNameplateCustomizer();